import axios from 'axios';
import storage from '../helpers/storage';
import { currentPath, loginUrlFor } from '../helpers/redirect';

// 1. Store the interceptor ID here. (JavaScript equivalent: no type annotation needed)
let globalInterceptorId = null;

// 1. Create the base Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Attaches a response interceptor to handle 401 Unauthorized errors globally.
 * @param {function} navigate - The function used for navigation/redirection (e.g., from react-router-dom's useNavigate).
 */
export const setupGlobalInterceptor = (navigate) => {
    // 2. FIX: If an ID exists, use the public 'eject' method to remove the old one.
    if (globalInterceptorId !== null) {
        axiosInstance.interceptors.response.eject(globalInterceptorId);
    }
    
    // 3. Store the returned ID.
    globalInterceptorId = axiosInstance.interceptors.response.use(
        // Successful responses are passed through
        (response) => response,
        
        // Error responses are handled here
        async (error) => {
            const { response } = error;

            // Check if the response status is 401 Unauthorized
            if (response && response.status === 401) {
                console.warn('--- Global 401 UNAUTHORIZED DETECTED ---');
                
                // 1. Clear authentication token/data
                if (storage) {
                     storage.clearAuth();
                } else {
                    console.error("Storage helper not available for 401 cleanup.");
                }

                // 2. Send them to the login, carrying where they were so
                // they come back to it rather than to the dashboard.
                if (navigate) {
                    navigate(loginUrlFor(currentPath()));
                }
                
                // Return a promise that never resolves/rejects to stop the error 
                // from propagating to the component's try/catch block.
                return new Promise(() => {}); 
            }

            // For all other errors (e.g., 404, 500, network errors), propagate the error.
            return Promise.reject(error);
        }
    );
};

export default axiosInstance;